export default "/_next/static/images/control_colors-04401d82fbc2a6f3a8abb3b57d051491.png";